import { GraphQLFieldConfig, GraphQLNonNull } from 'graphql'
import {
  libraryAggregationType,
  LibraryAggregation
} from '../types/library-aggregation'
import { Context } from '../shared'
import {
  libraryFilterArgs,
  LibraryFilterQueryArgs
} from '../types/library-filter-query-args'
import {
  appendLibraryFiltersToBody,
  ContrastQueryParameters
} from '../endpoint-helpers'
import { extractTermBuckets, extractKeyValueBuckets } from './helpers/shared'

type LibraryBucket =
  | 'tags'
  | 'servers'
  | 'apps'
  | 'languages'
  | 'licenses'
  | 'grades'
  | 'status'
  | 'usage'
  | 'environments'

export const libraryAggregations: GraphQLFieldConfig<
  any,
  Context,
  LibraryFilterQueryArgs
> = {
  description: 'Get the aggregation for a collection of libraries',
  type: new GraphQLNonNull(libraryAggregationType),
  args: libraryFilterArgs,
  async resolve(_source, args, context): Promise<LibraryAggregation> {
    const { organizationID, filters } = args

    const params = new ContrastQueryParameters()
    params.append('expand', 'skip_links')
    const mappedFilters = appendLibraryFiltersToBody(filters)

    const getAggregation = (bucketType: LibraryBucket) =>
      context.connector.post(
        `${organizationID}/libraries/filters/${bucketType}/listing?${params}`,
        mappedFilters
      )

    const [
      tags,
      servers,
      applications,
      languages,
      licenses,
      grades,
      status,
      usage,
      environments
    ] = await Promise.all([
      getAggregation('tags').then(extractTermBuckets),
      getAggregation('servers').then(extractKeyValueBuckets),
      getAggregation('apps').then(extractKeyValueBuckets),
      getAggregation('languages').then(extractTermBuckets),
      getAggregation('licenses').then(extractTermBuckets),
      getAggregation('grades').then(extractTermBuckets),
      getAggregation('status').then(extractKeyValueBuckets),
      getAggregation('usage').then(extractKeyValueBuckets),
      getAggregation('environments').then(extractKeyValueBuckets)
    ])

    return {
      tags,
      servers,
      applications,
      languages,
      licenses,
      grades,
      status,
      usage,
      environments
    }
  }
}
